import $ from 'jquery';
import Modal from '@shopify/marketing-assets/javascripts/modules/modal';
import ContactForm from '../modules/contact-form';

function initializeContestForm() {
  const $contestFormModalTrigger = $('.js-contest-modal-trigger');

  if ($contestFormModalTrigger.length) {
    const $template = $('.js-modal-template').first().detach();

    new Modal($contestFormModalTrigger, () => {
      return $template;
    }, {
      modalStyleModifierClasses: {
        container: 'modal-container--highlight background-off-white',
        closeIcon: 'icon-close-black',
      },
      afterModalRender: () => {
        setUpContestForm();
      },
    });
  }

  setUpContestForm();
}

function emailOptInChangeHandler($emailOptIn, $contestForm) {
  $emailOptIn.on('change', (el) => {
    $contestForm.find('button[type=submit]').attr('disabled', !el.currentTarget.checked);
  });
}

function setUpContestForm() {
  const $contestForm = $('.js-contest-form');
  const $emailOptIn = $('.js-subscription-opt-in');

  emailOptInChangeHandler($emailOptIn, $contestForm);

  if ($contestForm.length) {
    new ContactForm($contestForm, {
      subsciptionData: {},
      analytics: {
        optimizelyEvent: 'ContestEntry',
        gaCategory: 'contest_form_submit',
        gaAction: 'success',
        gaSubscribeAction: 'contest_form',
        fbqSubscriptionEvent: 'EnterContestSuccess',
      },
    });
  }
}

export default initializeContestForm;
